import React from 'react';

import MercedesBenzLogo from '../../../../img/brands/brand-mercedes-benz.svg';
import FordLogo from '../../../../img/brands/brand-ford.svg';
import SmartLogo from '../../../../img/brands/brand-smart.svg';
import VoyahLogo from '../../../../img/brands/brand-voyah.svg';
import DongfengLogo from '../../../../img/brands/brand-dongfeng.svg';

const BRAND_LOGOS = [
	{key: 'Mercedes-Benz', logo: MercedesBenzLogo},
	{key: 'Ford', logo: FordLogo},
	{key: 'Smart', logo: SmartLogo},
	{key: 'Voyah', logo: VoyahLogo},
	{key: 'Dongfeng', logo: DongfengLogo},
];

const getBrandChoices = (filters) => {
	const brandGroup = filters.find(f => f.key === 'brand');
	if (!brandGroup || !brandGroup.filters[0]) return [];
	return brandGroup.filters[0].choices || [];
};

export default function BrandLogoBar({filters, onBrandToggle}) {
	const choices = getBrandChoices(filters);

	if (choices.length === 0) return null;

	return (
		<div className="brand-logo-bar">
			{BRAND_LOGOS.map(({key, logo}) => {
				const choice = choices.find(
					c => c.key.toLowerCase() === key.toLowerCase() || c.name.toLowerCase() === key.toLowerCase()
				);
				if (!choice) return null;

				const isActive = choice.active || false;

				return (
					<button
						key={key}
						type="button"
						className={`brand-logo-bar__item${isActive ? ' brand-logo-bar__item--active' : ''}`}
						onClick={() => onBrandToggle(choice.key || choice.name)}
						title={key}
					>
						<img src={logo} alt={key} />
					</button>
				);
			})}
		</div>
	);
}
